export const API_URL = "https://api.goshy.digital";
export const CLOUDFLARE_TURNSTILE_SITEKEY = "0x4AAAAAAAMVSakIeP3P-EEH";
export const LOGO_URL = "https://i.imgur.com/EqAoJKF.png";
export const STORE_NAME = "TopAlts";